import { sendGATracking } from "~/components/tracking/google-analytics/apis";

export const useTracking = () => {
  // cSpell:ignore Recriculation

  const trackImpression = () => {
    sendGATracking({
      action: "Series Recirculation Widget/LHS/Impression",
      category: "Series Recriculation Widget",
      label: "",
    });
  };

  const trackClick = () => {
    sendGATracking({
      action: "Series Recirculation Widget/LHS/Click",
      category: "Series Recriculation Widget",
      label: window.location.href,
    });
  };

  return {
    trackClick,
    trackImpression,
  };
};
